import React, { useState, useEffect, useRef } from 'react';
import { ChevronDown, Check } from 'lucide-react';
import { useCurrency } from './CurrencyContext';

const CurrencySwitcher = ({ darkMode = false }) => {
  const { currency, changeCurrency, SUPPORTED } = useCurrency();
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    const close = (e) => {
      if (ref.current && !ref.current.contains(e.target)) setOpen(false);
    };
    document.addEventListener('mousedown', close);
    return () => document.removeEventListener('mousedown', close);
  }, []);

  const color = darkMode ? '#F5EDDF' : '#2D5A3D';
  const bg = darkMode ? 'transparent' : 'transparent';

  return (
    <div className="relative" ref={ref}>
      <button
        onClick={() => setOpen((s) => !s)}
        className="inline-flex items-center gap-1.5 text-[13px] font-medium btn-hover"
        style={{ color, backgroundColor: bg }}
        aria-label="Change currency"
      >
        <span>{currency}</span>
        <ChevronDown size={14} />
      </button>
      {open && (
        <div
          className="absolute right-0 mt-2 w-44 rounded-xl shadow-lg overflow-hidden z-[100]"
          style={{ backgroundColor: '#FFFFFF', border: '1px solid rgba(45,90,61,0.15)' }}
        >
          {SUPPORTED.map((c) => {
            const active = c.code === currency;
            return (
              <button
                key={c.code}
                onClick={() => {
                  changeCurrency(c.code);
                  setOpen(false);
                }}
                className="flex items-center justify-between w-full px-3 py-2.5 text-left text-[13px] btn-hover hover:bg-[#F5EDE0]"
                style={{ color: '#2C2418' }}
              >
                <span className="flex items-center gap-2">
                  <span className="text-base">{c.flag}</span>
                  <span>
                    {c.code} – <span className="opacity-70">{c.label}</span>
                  </span>
                </span>
                {active && <Check size={14} color="#2D5A3D" />}
              </button>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default CurrencySwitcher;
